<template>
  <div>
    <tabSimulador :tab="tabValor" :itemsTabs="tabEstudiante" @change-tab="changetab"></tabSimulador>
    <!-- LOADER INICIAR VISTA  -->
    <v-dialog v-model="loadingSpiner.estado" :width="loadingSpiner.ancho">
      <v-card :color="loadingSpiner.colorDialog" dark>
        <v-card-text class="pt-2 text-center">
          {{ loadingSpiner.titulo }}
          <v-progress-linear indeterminate :color="loadingSpiner.color" class="mb-0">
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "@/helpers/axios";

export default {
  name: "simuladorPrincipal",
  components: {
    tabSimulador: () => import("./components/Co-tabSimulador.vue"),
  },
  data: () => ({
    // PROPIEDAD DEL COMPONENTE TABULADOR
    tabValor: null,
    detallePerfil: "",
    datoLogin: sessionStorage,
  }),
  methods: {
    changetab(e) {
      const me = this;
      me.tabValor = e;
      // console.log("desde el padre Store: " + e);
    },

    async init() {
      const me = this;
      const response = await axios.get(
        "/simulador/simuladorExamen/simuladorExamenes/simuladorE/capturePerfilSubmodulos/" +
        me.datoLogin.id_perfil
      );

      // console.log(response);

      let dataArray = [];
      response.data.forEach((element) => {
        dataArray.push(element.link_submodulo);
      });

      // console.log(dataArray);
      let ArrayTabs = [];
      switch (true) {
        case dataArray.includes("/gestionSimulador"):
          ArrayTabs = [
            {
              id: 1,
              titulo: "Asignar simulador de examen",
              icono: "fas fa-plus",
              contenido: "tab1",
              route: "/gestionSimulador",
              route_name: "simuladorDocenteInit",
              class: "font-weight-black",
            },
            {
              id: 2,
              titulo: "Simuladores de examen propuestos",
              icono: "fas fa-align-justify",
              contenido: "tab2",
              route: "/lista_docente_simuladores",
              route_name: "simuladorDocenteLista",
              class: "font-weight-black",
            },
          ];
          break;

        case dataArray.includes("/simulador_familia"):
          ArrayTabs = [
            {
              id: 1,
              titulo: "Crear simulador de examen",
              icono: "fas fa-plus",
              contenido: "tab3",
              route: "/simulador_familia",
              route_name: "simuladorFamiliaInit",
              class: "font-weight-black",
            },
            {
              id: 2,
              titulo: " Ver simuladores de examen",
              icono: "fas fa-align-justify",
              contenido: "tab4",
              route: "/lista_familia_simuladores",
              route_name: "simuladorFamiliaLista",
              class: "font-weight-black",
            },
          ];
          break;

        case dataArray.includes("/mis_simuladores"):
          ArrayTabs = [
            {
              id: 1,
              titulo: "Crear simulador de examen",
              icono: "fas fa-plus",
              contenido: "tab5",
              route: "/mis_simuladores",
              route_name: "simuladorInit",
              class: "font-weight-black",
            },
            {
              id: 2,
              titulo: "Mis simuladores de examen",
              icono: "fas fa-align-justify",
              contenido: "tab6",
              route: "/lista_simuladores",
              route_name: "simuladorList",
              class: "font-weight-black",
            },
          ];
          break;
      }

      this.$store.commit("getArrayTab", ArrayTabs);
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(["loadingSpiner", "tabEstudiante"]),
  },
};
</script>
<!-- CAMBIO -->
<style>
#nprogress .bar {
  height: 3px;
  /* Adjust the height value as desired */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
